<template>
  <el-container>
    <el-aside style="width:100px;">
      <el-menu default-active="0201" class="el-menu-vertical-demo" @select="handleSelect">
        <el-menu-item index="0201">路政管理</el-menu-item>
        <el-menu-item index="0202">运政管理</el-menu-item>
        <el-menu-item index="0203">地方海事</el-menu-item>
      </el-menu>
    </el-aside>
    <el-container v-show="!isRequest">
      <luzheng v-if="activeIndex == '0201'" @updateInfo="updateInfo"></luzheng>
      <yunzheng v-else-if="activeIndex == '0202'" @updateInfo="updateInfo"></yunzheng>
      <haishi v-else-if="activeIndex == '0203'" @updateInfo="updateInfo"></haishi>
    </el-container>
    <el-container v-show="isRequest">
      <div class="container" v-html="html" style="padding:10px;"></div>
    </el-container>
  </el-container>
</template>

<script>
//src/pages/queryOnline/components/lawEnforcementInfo/index1.vue
import luzheng from "@/pages/queryOnline/components/lawEnforcementInfo/index1.vue";
import yunzheng from "@/pages/queryOnline/components/lawEnforcementInfo/index2.vue";
import haishi from "@/pages/queryOnline/components/lawEnforcementInfo/index3.vue";
import Axios from "axios";
export default {
  data() {
    return {
      ipconfig: "http://116.115.106.58:17701/getfile/publiclist",
      activeIndex: "0201",
      isRequest: false,
      html: ""
    };
  },
  components: {
    luzheng,
    yunzheng,
    haishi
  },
  methods: {
    updateInfo(data) {
      // 点击子组件按钮时触发事件
      console.log(data);
      this.getDatas(data);
      //this.msg = data.city; // 改变了父组件的值
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      this.isRequest = false;
      // this.onLoadData(key);
      // this.html = "";
      // this.isRequest = false;
      // this.currentPage = 1;
    },
    getDatas(options) {
      let _this = this;
      var data = {
        filed: options.filed,
        filename: options.title + ".docx"
      };
      Axios.post(_this.ipconfig, data).then(
        function(res) {
          var content = `<div><h2 style='font-weight:bold;text-align:center;font-size:20px;'>${options.title}</h2><h4 style='text-align:center;margin-top:10px;'>时间：${options.time}</h4><hr></div>`;
          _this.html = content + res.data.html;
          _this.isRequest = true;
        }
      );
    }
  }
};
</script>

<style scoped>
.container >>> table tr td {
  border: 1px solid #333;
  padding: 5px;
}
.container >>> table tr td:first-child {
  min-width: 120px;
  max-width: 200px;
  vertical-align: 50%;
}
</style>


// WEBPACK FOOTER //
// src/pages/queryOnline/childPage/lawEnforcementInfo.vue



// WEBPACK FOOTER //
// src/pages/queryOnline/childPage/lawEnforcementInfo.vue